import {defineStore} from 'pinia'
import {saveAs} from 'file-saver';

export const useSepaDirectDebitExportStore = defineStore({
    id: 'sepa_direct_debit_exports',
    state: () => ({
        exports: [],
        itemLength: 0,
        currentExport: null,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 25,
        },
    }),
    getters: {},
    actions: {
        index(params = {}) {
            this.loading = true
            return this.apiClient.get('/sepa_direct_debit_exports', {
                params: {
                    page: this.serverOptions.page + 1,
                    size: this.serverOptions.rows,
                    ...params,
                },
            }).then(({data}) => {
                this.exports = data.sepa_direct_debit_exports
                this.itemLength = data.itemLength
                this.loading = false
                return data
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        show(exportId) {
            this.loading = true
            this.currentExport = null
            return this.apiClient.get(`/sepa_direct_debit_exports/${exportId}`).then(({data}) => {
                this.currentExport = data.sepa_direct_debit_export || data
                this.loading = false
                return this.currentExport
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        createFromInvoice(invoiceId) {
            this.loading = true
            return this.apiClient.post('/sepa_direct_debit_exports', {invoice_ids: [invoiceId]}).then(({data}) => {
                this.currentExport = data.sepa_direct_debit_export || data
                this.loading = false
                return this.currentExport
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        createFromPaymentBookings(paymentBookingIds) {
            this.loading = true
            return this.apiClient.post('/sepa_direct_debit_exports', {payment_booking_ids: paymentBookingIds}).then(({data}) => {
                this.currentExport = data.sepa_direct_debit_export || data
                this.loading = false
                return this.currentExport
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        downloadXml(exportId, filename = null) {
            return this.apiClient.get(`/sepa_direct_debit_exports/${exportId}/xml`, {responseType: 'blob'}).then(({data}) => {
                saveAs(data, filename || `sepa-direct-debit-export-${exportId}.xml`)
            })
        },
        submit(exportId) {
            this.loading = true
            return this.apiClient.put(`/sepa_direct_debit_exports/${exportId}/submit`).then(({data}) => {
                this.currentExport = data.sepa_direct_debit_export || data
                this.loading = false
                return this.currentExport
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        discard(exportId) {
            this.loading = true
            return this.apiClient.put(`/sepa_direct_debit_exports/${exportId}/discard`).then(({data}) => {
                this.currentExport = data.sepa_direct_debit_export || data
                this.loading = false
                return this.currentExport
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
    },
})
